import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_PORTFOLIO: MijnRoute = {
    path: ':id/portefeuille',
    navigationEvent: 'toPortfolio',
    regex: /^\/beleggen\/[^/]+\/portefeuille$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/portefeuille'
};
